.form {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
}

.formRow {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--space-4);
}

.formActions {
  display: flex;
  justify-content: flex-end;
  gap: var(--space-3);
  margin-top: var(--space-2);
  padding-top: var(--space-4);
  border-top: 1px solid var(--border);
}

@media (max-width: 560px) {
  .formRow { grid-template-columns: 1fr; }
}

/* -------------------------------------------------------------- toolbar */
.tableToolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-3);
  padding: var(--space-3) var(--space-4);
  border-bottom: 1px solid var(--border);
}

.search {
  flex: 1;
  max-width: 320px;
  padding: var(--space-2) var(--space-3);
  font-size: var(--text-sm);
  color: var(--text);
  background: var(--bg);
  border: 1px solid var(--border-strong);
  border-radius: var(--radius);
}

.search:focus {
  outline: none;
  border-color: var(--indigo);
  box-shadow: 0 0 0 3px rgb(79 63 240 / 15%);
}

/* Which mentors the list shows. Matches .search so the toolbar reads as one
   row of controls rather than a search box with an ornament beside it.
   `margin-left: auto` is deliberately absent: the count keeps that job. */
.filter {
  padding: var(--space-2) var(--space-3);
  font-size: var(--text-sm);
  color: var(--text);
  background: var(--bg);
  border: 1px solid var(--border-strong);
  border-radius: var(--radius);
  cursor: pointer;
}

.filter:focus {
  outline: none;
  border-color: var(--indigo);
  box-shadow: 0 0 0 3px rgb(79 63 240 / 15%);
}

.count {
  font-size: var(--text-xs);
  color: var(--text-muted);
  font-variant-numeric: tabular-nums;
  margin-left: auto;
}

/* ----------------------------------------------------------- table cells */
.mentorCell {
  display: flex;
  align-items: center;
  gap: var(--space-3);
}

.avatar {
  width: 32px;
  height: 32px;
  display: grid;
  place-items: center;
  /* Teal is the mentor accent throughout the product — the mockups' instinct,
     kept so the app and the portal agree. */
  background: var(--teal-soft);
  color: var(--teal);
  font-size: var(--text-xs);
  font-weight: var(--weight-semibold);
  border-radius: 50%;
  flex-shrink: 0;
}

.mentorText {
  display: flex;
  flex-direction: column;
  min-width: 0;
  line-height: 1.35;
}

.mentorName {
  font-weight: var(--weight-medium);
  color: var(--text);
}

.mentorEmail {
  font-size: var(--text-xs);
  color: var(--text-muted);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 24ch;
}

.categoryList {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-1);
  max-width: 22ch;
}

.ratingCount {
  color: var(--text-subtle);
  font-weight: var(--weight-normal);
  font-size: var(--text-xs);
}

.muted { color: var(--text-subtle); }

.rowActions {
  display: flex;
  justify-content: flex-end;
  gap: var(--space-1);
  /* Three ghost buttons sit on one line. Without this they wrap into a ragged
     stack on a narrower window and the row height jumps per mentor. */
  flex-wrap: nowrap;
  white-space: nowrap;
}

/* *** THE ACTION ROW MUST NOT SCROLL AWAY ***
   Every form renders its buttons inside the modal body rather than the
   Modal's own footer slot, so on a long form they scrolled out of reach —
   the "Add mentor" dialog showed a clipped Cancel/Save. Sticking the row to
   the bottom of the scroll container keeps them reachable without having to
   restructure each page.

   The negative margins let the sticky bar span the body's full width, so its
   background covers the content sliding underneath rather than leaving a gap. */
.formActions {
  position: sticky;
  bottom: calc(var(--space-5) * -1);
  z-index: 1;
  margin: var(--space-2) calc(var(--space-5) * -1) calc(var(--space-5) * -1);
  padding: var(--space-4) var(--space-5);
  background: var(--bg-sunken);
  border-top: 1px solid var(--border);
}

@media (max-width: 480px) {
  .formActions {
    flex-direction: column-reverse;
  }
  .formActions > * {
    width: 100%;
  }
}

/* An overridden rating must not read as a real one at a glance, so it is
   tinted and carries the figure it replaced underneath. */
.ratingOverridden {
  display: inline-flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 1px;
  color: var(--indigo);
  font-weight: var(--weight-semibold);
}

.ratingWas {
  font-size: var(--text-xs);
  font-weight: var(--weight-normal);
  color: var(--text-muted);
  white-space: nowrap;
}
